import { render, staticRenderFns } from "./SidebarProfileMenu.vue?vue&type=template&id=4ad4136e&scoped=true"
import script from "./SidebarProfileMenu.vue?vue&type=script&lang=js"
export * from "./SidebarProfileMenu.vue?vue&type=script&lang=js"
import style0 from "./SidebarProfileMenu.vue?vue&type=style&index=0&id=4ad4136e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad4136e",
  null
  
)

export default component.exports